export default "__VITE_ASSET__CiUfODHa__"